import React from 'react';
import HomeAnnouncements from './HomeAnnouncements';
import PersonalLinks from './PersonalLinks';
import DevelopmentNews from './DevelopmentNews';
import MissionVideo from './MissionVideo';

function Home() {
  return (
    <div className="contentwrapper bravo-ds">
      <div className="home-scroll">
        <div className="home-inner">
          <HomeAnnouncements />
          <PersonalLinks />
          <DevelopmentNews />
          <MissionVideo />
        </div>
      </div>
    </div>
  );
}

export default Home;
